import axios from "axios";
axios.defaults.headers.common["Is-Axios"] = true;
axios.defaults.headers["X-Requested-With"] = "Axios";
import Utilities from "../../../Helpers/Utilities";
import { receivedServerError, receivedUnauthorizedError, receivedExpiredSessionError } from "../../Error/Actions";
import { RECEIVED_TOKEN } from "../Constants";

export function getXsrfToken(cb) {
    return function(dispatch) {
        return axios.get(Utilities.buildUrl("/XsrfToken/Get"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedToken(res.data));

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(receivedServerError(true, error.response.data));
                dispatch(receivedServerError(false));
            });
    };
}

function receivedToken(data) {
    return {
        type: RECEIVED_TOKEN,
        payload: data
    };
}